import PropTypes from 'prop-types';

import { stepsFactory } from 'components/Booking-new/utils/steps';

import PersonalDataContainer from './PersonalDataContainer';

import VariantA from './Variants/VariantA';

const personalDataVariants = {
  a: VariantA,
};

const personalDataStepWrapper = PersonalDataContainer;

const PersonalData = ({ variant, data, navigation, userData }) => {
  return stepsFactory(personalDataVariants, variant, { data, navigation, userData }, personalDataStepWrapper);
};

PersonalData.propTypes = {
  variant: PropTypes.oneOf(['a']).isRequired,
  data: PropTypes.shape({
    __typename: PropTypes.string,
    ageConsentError: PropTypes.string.isRequired,
    ageConsentLabel: PropTypes.string.isRequired,
    enableMarketingConsentLabel: PropTypes.bool,
    enableMarketingDisclaimer: PropTypes.bool,
    marketingConsentLabel: PropTypes.string,
    marketingConsentDisclaimer: PropTypes.object,
    bookButtonLabel: PropTypes.string,
    rescheduleHeadlineStepFinalize: PropTypes.string,
    rescheduleQuestionStepFinalize: PropTypes.string,
    rescheduleLinkLabelStepFinalize: PropTypes.string,
    emailError: PropTypes.string,
    emailLabel: PropTypes.string,
    firstNameError: PropTypes.string,
    firstNameLabel: PropTypes.string,
    cityLabel: PropTypes.string,
    cityLabelError: PropTypes.string,
    hasBorder: PropTypes.bool,
    id: PropTypes.string,
    invalidNameError: PropTypes.string,
    lastNameError: PropTypes.string,
    lastNameLabel: PropTypes.string,
    name: PropTypes.string,
    nextStep: PropTypes.number,
    phoneNumberError: PropTypes.string,
    phoneNumberLabel: PropTypes.string,
    title: PropTypes.string,
    showNewBookingStepHeader: PropTypes.bool,
    userConsent: PropTypes.shape({
      raw: PropTypes.string,
      references: PropTypes.arrayOf(
        PropTypes.shape({
          __typename: PropTypes.string,
          contentful_id: PropTypes.string,
          hasBackground: PropTypes.bool,
          isButton: PropTypes.bool,
          title: PropTypes.string,
          type: PropTypes.bool,
          url: PropTypes.string,
        }),
      ),
    }),
  }),
};

export default PersonalData;
